import {axios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
import {useState} from "../../../__snowpack__/pkg/react.js";
import _axios from "../../../__snowpack__/pkg/axios.js";
const CancelToken = _axios.CancelToken;
let cancelRequeset;
export const useMainContentTableData = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (pageInfo, search) => {
    setLoading(true);
    let api;
    if (search && search.outboundOrderType === "SELL") {
      api = "/saas/sellOutboundOrders/search";
    } else {
      api = "/saas/manualOutboundOrders/search";
    }
    typeof cancelRequeset == "function" && cancelRequeset();
    try {
      let {data: data2} = await axios.post(api, {
        page: pageInfo && pageInfo.page && pageInfo.page - 1,
        size: pageInfo && pageInfo.pageSize,
        ...search
      }, {
        cancelToken: new CancelToken(function executor(c) {
          cancelRequeset = c;
        })
      }).catch((e) => {
        throw e;
      });
      if (!data2) {
        data2 = {
          content: [],
          number: 0,
          size: 150,
          totalElements: 0
        };
      }
      const {content, number: page, size: pageSize, totalElements: pageTotal} = data2;
      setData(content);
      return {
        tableData: content,
        pageInfo: {
          page: page + 1,
          pageSize,
          pageTotal
        }
      };
    } catch (error) {
      !(error instanceof _axios.Cancel) && handleError(error);
      return {
        tableData: data,
        pageInfo
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    tableDataLoading: loading,
    tableData: data,
    setTableData: setData,
    fetchTableData: fetchData
  };
};
